import { DateFormats } from '@strata/helper-functions';
import { StatusIndicator } from '@strata/react-status-indicators';
import dayjs from 'dayjs';

/**
 * Platform enrollment / eligibility values from scope-assessor member payload.
 * @typedef {'ACTIVE'|'PENDING'|'INACTIVE'} PlatformEligibilityStatus
 */

/** Raw `enrollment_status` value for delayed-unmanagement monitoring. */
export const PLATFORM_ELIGIBILITY_PENDING = 'PENDING';

/**
 * Calendar date (YYYY-MM-DD) when delayed unmanagement would flip PENDING coverage, or null.
 * @param {string|undefined|null} pendingAtIso - `pending_at` from member payload (ISO datetime).
 * @param {number|string|undefined|null} delayedUnmanagementDays - From benefit_check_config.
 * @returns {string|null}
 */
export const computeWillBeUnmanagedOnDate = (pendingAtIso, delayedUnmanagementDays) => {
    if (pendingAtIso == null) {
        return null;
    }
    const days = delayedUnmanagementDays;
    if (days == null || days <= 0) {
        return null;
    }
    return dayjs(pendingAtIso).add(days, 'day').format(DateFormats.HYPHEN_DATE);
};

const ELIGIBILITY_MAP = {
    ACTIVE: {
        label: 'ACTIVE',
        status: StatusIndicator.Status.SUCCESS,
        tooltipText: 'Member enrollment is active.',
    },
    PENDING: {
        label: 'MONITORING',
        status: StatusIndicator.Status.WARNING,
        tooltipText:
            'Monitoring enrollment. Coverage terms if active enrollment is not received before the grace period ends.',
    },
    INACTIVE: {
        label: 'TERMED',
        status: StatusIndicator.Status.CAUTION,
        tooltipText: 'Member enrollment is termed.',
    },
};

/**
 * Maps scope-assessor enrollment_status to Agora labels and StatusIndicator styling.
 *
 * @param {string|undefined|null} enrollmentStatus - Raw `enrollment_status` from the API.
 * @returns {{ label: string, status: string, tooltipText: string }|null}
 */
export const getMemberEligibilityStatusDisplay = (enrollmentStatus) => {
    if (enrollmentStatus == null) {
        return null;
    }
    const mapped = ELIGIBILITY_MAP[enrollmentStatus];
    if (mapped) {
        return mapped;
    }
    return {
        label: enrollmentStatus,
        status: StatusIndicator.Status.DEFAULT,
        tooltipText: undefined,
    };
};
